import React from 'react'
import { Breadcrumb } from 'element-react'

const BreadcrumbsSG = () => {
    return (
        <Breadcrumb separator="/">
            <Breadcrumb.Item>Homepage</Breadcrumb.Item>
            <Breadcrumb.Item>Promotion Management</Breadcrumb.Item>
            <Breadcrumb.Item>Promotion List</Breadcrumb.Item>
            <Breadcrumb.Item>Promotion Detail</Breadcrumb.Item>
        </Breadcrumb>
    )
}

export default BreadcrumbsSG
